import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import CurrencySelector from '@/common/components/CurrencySelector/CurrencySelector'
import { isEmptyValue, isRangeInvalid } from '@/common/components/MatchTypeEditor/helpers'
import { getCurrencySymbolByCode } from '@/common/helpers/helpers'

import { getMaxHelperText, getMinHelperText, sanitizeCurrencyValue, shouldShowError } from './helpers'
import * as Styles from './styles'

const RangeInput = ({
  value,
  onChange,
  disabled,
  matchCurrency,
  onChangeMatchCurrency,
  currencies,
  storeCurrencyCode,
  selectableCurrency,
  isCurrencyField,
  hasError,
  inputBackgroundColor,
}) => {
  const { t } = useTranslation()

  const minValue = value?.min_value ?? ''
  const maxValue = value?.max_value ?? ''

  const isMinEmpty = isEmptyValue(minValue)
  const isMaxEmpty = isEmptyValue(maxValue)

  const hasInvalidRange = isRangeInvalid(value?.min_value, value?.max_value)

  const showMinError = shouldShowError(hasError, isMinEmpty, hasInvalidRange)
  const showMaxError = shouldShowError(hasError, isMaxEmpty, hasInvalidRange)

  const minHelperKey = getMinHelperText(hasError, isMinEmpty)
  const maxHelperKey = getMaxHelperText(hasError, isMaxEmpty, hasInvalidRange)

  const selectedCurrency = matchCurrency || storeCurrencyCode
  const currencySymbol = isCurrencyField ? getCurrencySymbolByCode(selectedCurrency, currencies) : undefined

  const applyChange = (key, rawValue) => {
    const nextValue = isCurrencyField ? sanitizeCurrencyValue(rawValue) : rawValue
    if (nextValue !== null) onChange({ ...value, [key]: nextValue })
  }

  const handleMinChange = e => applyChange('min_value', e.target.value)
  const handleMaxChange = e => applyChange('max_value', e.target.value)

  const inputType = isCurrencyField ? 'text' : 'number'

  return (
    <Styles.Container>
      {selectableCurrency && (
        <CurrencySelector
          currencies={currencies}
          selectedCurrency={selectedCurrency}
          onChange={onChangeMatchCurrency}
          disabled={disabled}
          backgroundColor={inputBackgroundColor}
        />
      )}
      <Styles.Row>
        <InputWithLabel
          label={t('Valor mínimo')}
          value={minValue}
          onChange={handleMinChange}
          fullWidth
          type={inputType}
          disabled={disabled}
          startAdornment={currencySymbol}
          backgroundColor={inputBackgroundColor}
          error={showMinError}
          helperText={minHelperKey && t(minHelperKey)}
        />
        <InputWithLabel
          label={t('Valor máximo')}
          value={maxValue}
          onChange={handleMaxChange}
          fullWidth
          type={inputType}
          disabled={disabled}
          startAdornment={currencySymbol}
          backgroundColor={inputBackgroundColor}
          error={showMaxError}
          helperText={maxHelperKey && t(maxHelperKey)}
        />
      </Styles.Row>
    </Styles.Container>
  )
}

export default RangeInput
